export default function initializePortOne() {
  if (!window.IMP) return;
  const { IMP } = window;
  IMP.init("imp22682510");
  return IMP;
}
